export default "__VITE_ASSET__Dz8kuYQe__"